import GoodsInfo from "@/views/goods/cart/components/goods-info.vue"

export default {
    components: { GoodsInfo },
    emits: ["singleElection", "deleteCart", "change"],
    props: {
        siteItem: {
            type: Object,
            default: () => {
            }
        },
        item: {
            type: Object,
            default: () => {
            }
        },
        layoutClass: {
            type: String,
            default: ""
        }
    },
    computed: {
        //价格展示逻辑
        priceDisplayLogic() {
            const { goods_min, promotion_label, discount_price, price, is_discount } = this.item
            const goodsNum = this.limitPurchaseQuantity
            // 是否展示折扣价格判断 小于goods_min 展示原价 否则折扣价格
            const isDiscountApplicable = goodsNum >= goods_min
            // 检查商品是否属于阶梯活动
            if (promotion_label === "wholesale") {
                const tierList = this.item.promotion_info.price_json
                // 找到第一个满足当前购买数量的阶梯 反转数组 从高到低 找到合适的阶梯
                const tier = tierList.slice().reverse().find(t => Number(t.num) <= Number(goodsNum))
                const priceToDisplay = tier ? tier.price : isDiscountApplicable ? discount_price : price
                return {
                    actualPrice: priceToDisplay,
                    shouldShowDiscountIcon: true
                }
            }
            // 普通商品的逻辑
            // 当前数量小于goods_min 那么取原价 否则取discount_price
            return {
                actualPrice: isDiscountApplicable ? discount_price : price,
                shouldShowDiscountIcon: isDiscountApplicable && is_discount
            }
        },
        // 价格计算使用有效购买上限内的数量。
        limitPurchaseQuantity() {
            const num = Number(this.item.num)
            return num <= this.getMaxBuyQuantity ? num : this.getMaxBuyQuantity
        },
        /**
         * 获取最小购买数量
         * */
        getMinBuyQuantity() {
            return Number(this.item.min_buy) || 1
        },
        // 开启指定限购类型时按 max_buy 限制，否则按库存限制。
        getMaxBuyQuantity() {
            const { max_buy, stock, goods_stock, is_limit, limit_type } = this.item
            const maxBuy = Number(max_buy)
            const stockQuantity = Number(stock || goods_stock) || 0
            const isLimit = is_limit === 1 && limit_type === 1 && maxBuy > 0
            return isLimit ? maxBuy : stockQuantity
        },
        // 保留接口中已有的超限数量，同时禁用加号；用户修改时再按实际限额提交。
        getInputMaxQuantity() {
            return Math.max(Number(this.item.num) || 0, this.getMaxBuyQuantity)
        },
        //特价提示富文本
        bargainPriceMessageNodes() {
            return function(item) {
                let messages = []
                const messageStyle = "<p style=\"color: #f56c6c; font-size: 12px;\">"
                const currentQuantity = this.limitPurchaseQuantity
                if(item.promotion_info.num_multiple>1){
                    messages.push(`${messageStyle}提示：当前特价仅${item.promotion_info.num_multiple}的倍数可享受，超出按原价计算`)
                }
                // 使用传入的item参数
                if (item.promotion_type === 1 && item.is_member_discount === 0) {
                    if (item.goods_limit === 0) {
                        messages.push("<p style=\"color: #31BB6D; font-size: 12px;\">提示：本特价商品无限制数量</p>")
                    } else if (currentQuantity > item.goods_min && currentQuantity < item.goods_limit) {
                        messages.push(`${messageStyle}提示：限购活动您还可购买${item.goods_limit - currentQuantity}${item.unit}${messageStyle}`)
                    } else if (currentQuantity > item.goods_limit) {
                        messages.push(`${messageStyle}提示：您已超过限购数量${item.goods_limit}${item.unit}恢复原价${messageStyle}`)
                        messages.push(`${messageStyle}提示：特价￥${item.discount_price} x${item.goods_limit}，原价￥${item.price}x${currentQuantity - item.goods_limit}${messageStyle}`)
                    }
                }
                if (item.promotion_type === 1 && item.is_member_discount > 0) {
                    messages.push(`${messageStyle}提示：现已恢复原价！${messageStyle}`)
                }
                if (item.goods_min > 0) {
                    if (currentQuantity < item.goods_min) {
                        messages.push(`${messageStyle}提示：当前商品起购数量为${item.goods_min}${item.unit},小于${item.goods_min}${item.unit}将不享受折扣${messageStyle}`)
                    }
                }
                // 将带有样式的消息数组连接成一个HTML字符串
                return messages.join("")
            }
        }
    },
    methods: {
        cartNumChange(num, oldNum) {
            if (!num || num < this.getMinBuyQuantity) num = this.getMinBuyQuantity
            if (num > this.getMaxBuyQuantity) num = this.getMaxBuyQuantity
            this.$store
                .dispatch("cart/edit_cart_num", {
                    num,
                    cart_id: this.item.cart_id
                })
                .then(res => {
                    if (res.code >= 0) {
                        this.item.num = num
                        this.$emit("change")
                    } else {
                        this.item.num = oldNum
                        this.$message({
                            message: res.message,
                            type: "warning"
                        })
                    }
                })
                .catch(err => {
                    this.item.num = oldNum
                    this.$message.error(err.message)
                })
        }
    }
}
